var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessmanager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_383_58)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#16A085"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 8.5,
    width: 41,
    height: 41,
    rx: 20.5,
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1813 43.1667V36.5629C46.1813 35.2788 45.9979 33.9948 45.2642 32.7107C44.5304 31.4266 43.6132 30.326 42.3291 29.5922C41.0451 28.6751 38.2935 28.4916 37.0094 28.4916L34.0744 31.6101L35.1751 33.9948V39.4979L33.3407 41.5157L31.5063 39.4979V33.9948L32.7904 31.6101L29.6719 28.4916C28.2044 28.4916 25.4528 28.6751 24.1688 29.5922C22.8847 30.326 22.1509 31.4266 21.4172 32.7107C20.6834 33.9948 20.5 35.0954 20.5 36.5629V43.1667C20.5 43.1667 25.2694 43.1667 33.3407 43.1667C41.4119 43.1667 46.1813 43.1667 46.1813 43.1667ZM33.3407 14C29.8553 14 27.8375 17.3019 28.3878 20.9707C28.9244 24.5475 30.7725 25.9986 33.3407 25.9986C35.9088 25.9986 37.7432 24.8229 38.2935 20.9707C38.8438 17.1184 36.826 14 33.3407 14Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_383_58",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_383_58"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_383_58",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_383_58"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessmanager);
export default __webpack_public_path__ + "static/media/businessmanager.6d5a9528e761c08d4bcfeadfef6a40cc.svg";
export { ForwardRef as ReactComponent };